import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Layout, Button, message } from 'antd';
import { API_URL, BrokerBalanceData, LoadBrokerBalanceResponse, LoadBrokerBalanceResult, LoadOptListResponse, LoadOptListResult, UpdateOptResponse, UpdateOptResult } from "../constant";
import { FileExcelOutlined, ImportOutlined } from '@ant-design/icons';
import { api_uploadOPTcsv } from '../api/uploadExcel';
import { ColDef, GridOptions, themeQuartz } from 'ag-grid-community';
import CustomLoadingOverlay from '../components/CustomLoadingOverlay';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import { api_LoadBrokerBalanceList, api_ReportBrokerBalance, api_ReportOpt, api_updateOpt, api_updateOptNotes, LoadOptBalanceList, LoadOptList } from '../api/loadOPTList';
import { on } from 'events';
import { DownloadExcelHistory } from '../api/excelhistory';

const HeaderStyle: React.CSSProperties = {
    height: '50px',
};

export function isLoadBrokerBalanceResult(result: LoadBrokerBalanceResult): result is LoadBrokerBalanceResponse {
    return result.success === true; 
}

const BrokerBalance: React.FC<{ user: { [key: string]: string }, isSelected: boolean }> = ({ user, isSelected }) => {

    const [loading, setLoading] = useState(false)
    const [rowData, setRowData] = useState<BrokerBalanceData[]>([]);
    const [brokerlist, setOptList] = useState<BrokerBalanceData[]>([]);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const listRef = useRef(brokerlist);
    const gridRef = useRef<AgGridReact>(null);

    const [colDefs, setColDefs] = useState<ColDef[]>([
        { headerName: 'Broker Name', field: "BrokerName", width: 250, resizable: true, sortable: true},
        { headerName:'NPN', field: "NPN", width: 120, resizable: true, cellStyle: { textAlign: "right" }, sortable: true},
        { headerName:'StateID', field: "StateID", width: 120, resizable: true, cellStyle: { textAlign: "right" }, sortable: true
        },
        {
            headerName: 'Balance', field: "Balance", width: 150, resizable: true, cellStyle: { textAlign: "right" }, sortable: true,
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
    ]);

    useEffect(() => {
        listRef.current = brokerlist;
    }, [brokerlist]);


    useEffect(() => {
        onLoadBrokerBalanceList()
    }, []);

    const defaultColDef = useMemo<ColDef>(() => {
        return {
            headerClass: 'custom-header',
            sortable: false,
        };
    }, []);

    const myTheme = themeQuartz
        .withParams({
            headerColumnBorder: { color: 'gray' },
            headerColumnBorderHeight: '90%',
        });

    const onCellValueChanged = (params: any) => {
        
    };

    const onCellDoubleClicked = (params: any) => {

    };

    const isValidate = (data: any) => {
        return true
    }
 
    const gridOptions: GridOptions = {
        rowClassRules: {
            'row-red': params => params.data?.Invaild === false
        }
    };

    
    const onLoadBrokerBalanceList = () => {
        setLoading(true)
        api_LoadBrokerBalanceList()
        .then((optResult) => {

            if (optResult.success) {
                //message.success({ content: 'Successfully loaded Filing History', key: 'historyStatus', duration: 2  });
                if (isLoadBrokerBalanceResult(optResult)) {
                    // console.log(`Load OPT list success, ${JSON.stringify(optResult.optlist)}`);
                    setOptList(optResult.brokerlist)
                    setRowData(optResult.brokerlist)
                }
            }
            else {
                message.error({ content: 'Failed to load the OPT list', key: 'historyStatus', duration: 2 });
                if ("errorMsg" in optResult) {
                    message.error(optResult.errorMsg)
                }
            }
        })
        .catch((error) => {
            console.error("An error occurred:", error.message);
            return
        })
        .finally(() => {
            setLoading(false)
        });
    }

    const onClickReportOPTBtn = () => {
        api_ReportBrokerBalance()
        .then((borkersResult) => {
            if (borkersResult.success) {
                message.success({ content: 'Successfully reported Broker Balance', key: 'historyStatus', duration: 2  });
            }
            else {
                message.error({ content: 'Failed to report Broker Balance', key: 'historyStatus', duration: 2 });
                if ("errorMsg" in borkersResult) {
                    message.error(borkersResult.errorMsg)
                }
            }
        })
        .catch((error) => {
            console.error("An error occurred:", error.message);
            return
        })
        .finally(() => {
            setLoading(false)
        });
    }

  return (
    <div style={{ height: '100%' }} className='text-style'>
        <div className="flex justify-between items-center bg-gray-100" style={HeaderStyle}>
            {/* <div className='flex'>
                <Button
                variant="outlined"
                type='primary'
                onClick={handleImportCSV}
                icon={<ImportOutlined className='icon-style' />}
                className={`ml-10 button-style`}>
                ImportCSV
            </Button>
            <input
                    ref={fileInputRef}
                    type="file"
                    accept=".csv"
                    style={{ display: 'none' }} // Hide the file input
                    onChange={handleFileChange}
                />
            </div> */}
            <div className='flex flex-row ml-10 text-xs'>
                {/* <div><span>The red-highlighted rows have an incorrect License Number.</span></div> */}
            </div>
            <Button
                variant="outlined"
                type='primary'
                onClick={onClickReportOPTBtn}
                icon={<FileExcelOutlined className='icon-style' />}
                className='ml-0.5, mr-20 button-style'>
                Report
            </Button>
        </div>
        <div className="ag-theme-alpine  tab-container">
            <AgGridReact
                ref={gridRef}
                rowData={rowData}
                // gridOptions={gridOptions}
                columnDefs={colDefs}
                theme={myTheme}
                defaultColDef={defaultColDef}
                headerHeight={35}
                rowHeight={25}
                onCellDoubleClicked={onCellDoubleClicked}
                loading={loading}
                loadingOverlayComponent={CustomLoadingOverlay}
                loadingOverlayComponentParams={{ message: 'Loading...' }}

            />
        </div>
    </div>
  );
};

export default BrokerBalance;
